import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  checkCertificateStatus,
  deleteCertificate,
  getAllCertificates,
  getInstructions,
  requestCertificate,
} from "controller/api";
import { DeleteCertificateInput, RequestCertificateInput } from "shared";
import { sentryLogger } from "utilz";
import { addMixpanelEvent, debugConsole } from "utilz/helpers";

export const useRequestCertificate = () => {
  return useMutation({
    mutationFn: (data: RequestCertificateInput) => requestCertificate(data),
    onError: (err) => debugConsole(err),
    onSuccess: (data, variables, context) => {
      const newMessage = `${variables.mspId} added ${variables.domain} as ${variables.vanityUrlType} url`;
      sentryLogger({
        error: {
          message: newMessage,
          traceId: "",
          status: 200,
        },
        workflow: "controlCenter",
        level: "info",
        functionName: "useRequestCertificate",
        data: { ...variables, data: data },
      });

      addMixpanelEvent({
        event: "vanity_domain_added",
        data: {
          mspId: variables.mspId,
          domain: variables.domain,
          vanityUrlType: variables.vanityUrlType,
          data: data,
        },
      });
      // queryClient.invalidateQueries({ queryKey: ["allCertificates"] });
    },
  });
};

export const useCheckCertificateStatus = () => {
  return useMutation({
    mutationFn: (id: string) => checkCertificateStatus(id),
    onError: (err) => debugConsole(err),
  });
};

export const useGetInstructions = (id?: string) => {
  return useQuery({
    queryKey: ["instructions", id],
    queryFn: () => getInstructions(id || ""),
    onError: (err) => debugConsole(err),
    enabled: id ? true : false,
    staleTime: Infinity,
    cacheTime: Infinity,
  });
};

export const useGetAllCertificates = (mspId: string) => {
  return useQuery({
    queryKey: ["allCertificates", mspId],
    queryFn: () => getAllCertificates(mspId),
    onError: (err) => debugConsole(err),
    enabled: mspId ? true : false,
    // staleTime: Infinity,
    // cacheTime: Infinity,
  });
};

export const useDeleteCertificate = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (value: DeleteCertificateInput) => deleteCertificate(value),
    onError: (err) => debugConsole(err),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["allCertificates"] });
      queryClient.invalidateQueries({ queryKey: ["instructions"] });
    },
  });
};
